/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { User } from './user';


/**
 * (tsType: Partial<ReductionRequisitionStatusHistory>, schemaOptions: { partial: true })
 */
export interface ReductionRequisitionStatusHistoryPartial { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    comments?: string;
    statusId?: string;
    reductionRequisitionId?: string;
    changedBy?: User;
}

